<template>
	<div class="home">
		<ImageMarker />
	</div>
</template>

<script>
import ImageMarker from '@/components/ImageMarker'
export default {
	name: 'Home',
	components: {
		ImageMarker
	}
}
</script>
